import { createStore } from 'vuex';

const store = createStore({
  state: {
    adminLanguage: localStorage.getItem('adminLanguage') || 'es', // Idioma para el panel de administración
    publicLanguage: localStorage.getItem('publicLanguage') || 'es', // Idioma para la parte pública
  },
  mutations: {
    setAdminLanguage(state, language) {
      state.adminLanguage = language;
      localStorage.setItem('adminLanguage', language);
    },
    setPublicLanguage(state, language) {
      state.publicLanguage = language;
      localStorage.setItem('publicLanguage', language);
    },
  },
  actions: {
    changeAdminLanguage({ commit }, language) {
      commit('setAdminLanguage', language);
    },
    changePublicLanguage({ commit }, language) {
      commit('setPublicLanguage', language);
    },
  },
  getters: {
    currentAdminLanguage: (state) => state.adminLanguage,
    currentPublicLanguage: (state) => state.publicLanguage,
  },
});

window.addEventListener('storage', (event) => {
  if (event.key === 'adminLanguage') {
    store.commit('setAdminLanguage', event.newValue);
  }
  if (event.key === 'publicLanguage') {
    store.commit('setPublicLanguage', event.newValue);
  }
});

export default store;